import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDowngradeAlert } from '../../hooks/useDowngradeAlert';
import { useSubscription } from '../../hooks/useSubscription';
import { UpgradeModal } from './UpgradeModal';

export const DowngradeLimitsBanner = () => {
  const { hasExceeded, exceededItems } = useDowngradeAlert();
  const { plan } = useSubscription();
  const navigate = useNavigate();
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!hasExceeded || dismissed) return null;

  return (
    <>
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3.5">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-lg shrink-0 mt-0.5">
            <i className="ri-alert-line text-amber-600 text-base" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm font-700 text-amber-800">
              Itens acima do limite do seu plano atual
            </p>
            <p className="text-xs text-amber-600 mt-0.5 mb-3">
              Após o downgrade, você não pode criar novos itens até ficar dentro dos limites.
              Os itens existentes não foram removidos — ajuste manualmente para continuar.
            </p>

            <div className="flex flex-wrap gap-2">
              {exceededItems.map((item) => (
                <button
                  key={item.resource}
                  onClick={() => navigate(item.path)}
                  className="flex items-center gap-2 px-3 py-1.5 bg-white border border-amber-200 rounded-lg text-xs font-600 text-amber-800 hover:bg-amber-100 cursor-pointer whitespace-nowrap transition-colors"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${item.icon} text-amber-600 text-sm`} />
                  </div>
                  {item.current} {item.resourcePlural}
                  <span className="text-amber-400">→</span>
                  limite: {item.limit}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={() => setUpgradeOpen(true)}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-xs font-600 rounded-lg cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-vip-crown-line text-xs" />
              Fazer upgrade
            </button>
            <button
              onClick={() => setDismissed(true)}
              className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-amber-100 text-amber-400 hover:text-amber-600 cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-base" />
            </button>
          </div>
        </div>
      </div>

      <UpgradeModal
        open={upgradeOpen}
        onClose={() => setUpgradeOpen(false)}
        title="Aumente seus limites"
        description={`Seu plano ${plan?.name ?? 'atual'} tem limites que estão sendo ultrapassados. Faça upgrade para gerenciar sem restrições.`}
      />
    </>
  );
};
